.root {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 40px;
  background: #f8f7f4;
  z-index: 11; //mask is 10
  transform: translateY(-100vh);
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05), 0 1px 5px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  .innerGrid {
    display: grid;
    grid-template-columns: auto auto 1fr;
    justify-content: flex-start;
    // align-items: flex-start;
    width: 1080px;
    height: 352px;
    .leftArea {
      padding-right: 64.5px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      border-right: 1px solid #161a2133;
      padding-top: 16px;
      padding-bottom: 16px;
      .leftAreaContent {
        display: grid;
        row-gap: 40px;
        grid-auto-columns: 1fr;
        .item {
          .title {
            font-family: Montserrat;
            font-size: 32px;
            font-style: normal;
            font-weight: 700;
            line-height: 32px;
            letter-spacing: -0.02em;
            text-align: left;
            color: #161a21;
            text-transform: uppercase;
            transition: 0.3s ease all;
            cursor: pointer;
            opacity: 0.4;
            white-space: nowrap;
            text-decoration: none;
            &:hover {
              opacity: 0.7;
            }
          }
          .childItems {
            margin-top: 20px;
            display: grid;
            grid-template-rows: 1fr;
            row-gap: 16px;
            .childTitle {
              color: #161a21;
              text-decoration: none;
              font-family: Montserrat;
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: 14px;
              letter-spacing: 0.02em;
              text-align: left;
              text-transform: uppercase;
              transition: 0.3s ease all;
              cursor: pointer;
              opacity: 0.4;

              &:hover {
                opacity: 0.7;
              }
            }
          }
          &.active {
            .title {
              opacity: 1;
            }
            .childTitle {
              opacity: 1;
            }
          }
        }
      }
    }
    .rightArea {
      margin-left: 64.5px;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;
      align-items: center;
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }
}
.maskRoot {
  top: 80px !important;
  // background-color: transparent !important;
  border: none;
}
